import * as React from "react";
import {useEffect, useState} from "react";
import {Header} from "../components/Header";
import {toast} from "react-toastify";
import i18next, {t} from "i18next";
import {EventRegistrationForm} from "../components/EventRegistrationForm";
import {getAllActiveEvents} from "../service/eventApi";
import {useAxiosPrivate} from "../hooks/useAxiosPrivate";
import {EventTicketModal} from "../components/EventTicketModal";
import {useNavigate} from "react-router-dom";
import {useAuth} from "../hooks/useAuth";

export const NewsAndEvents = () => {
	const {isAuthenticated} = useAuth();
	const navigate = useNavigate();

	const axiosPrivate = useAxiosPrivate();

	const [loadingEventsPageBaseData, setLoadingEventsPageBaseData] = useState(true);
	const [eventsData, setEventsData] = useState([]);

	const [selectedModeOfAttending, setSelectedModeOfAttending] = useState("");
	const [selectedEventDetails, setSelectedEventDetails] = useState({
		id: "",
		title: "",
		bannerUrl: "",
		// eventDate: "",
		// eventTime: "",
		// eventLocation: "",
		// eventDescription: "",
	});
	const [showEventRegistrationModal, setShowEventRegistrationModal] = useState(false);

	const [selectedTicketDetails, setSelectedTicketDetails] = useState({
		_id: '',
		userId: '',
		eventId: '',
		numberOfSeats: '',
		qrCodeBase64: '',
		rowNumber: '',
		modeOfAttending: '',
	});
	const [showEventTicketModal, setShowEventTicketModal] = useState(false);

	function getDaySuffix(day) {
		if (day >= 11 && day <= 13) {
			return 'th';
		}
		switch (day % 10) {
			case 1:
				return 'st';
			case 2:
				return 'nd';
			case 3:
				return 'rd';
			default:
				return 'th';
		}
	}

	function convertUTCDate(utcDateString, language = 'mr') {
		const date = new Date(utcDateString);
		const timeZone = 'Asia/Kolkata'; // Ensure correct timezone for India

		let options;
		let locale;

		if (language === 'en') {
			options = {
				year: 'numeric',
				month: 'long',
				day: 'numeric',
				timeZone: timeZone
			};
			locale = 'en-IN'; // Use en-IN for proper day numbering (e.g., 25th)
			const dateFormatter = new Intl.DateTimeFormat(locale, options);
			const day = date.getDate();
			const formattedDate = dateFormatter.format(date).replace(day, `${day}${getDaySuffix(day)}`);
			return formattedDate.replace(/(\d+)(st|nd|rd|th)\s(\w+)\s(\d+)/, '$1$2 $3, $4'); // Add the comma
		} else if (language === 'mr') {
			options = {
				year: 'numeric',
				month: 'long',
				day: 'numeric',
				timeZone: timeZone
			};
			locale = 'mr-IN';
			const dateFormatter = new Intl.DateTimeFormat(locale, options);
			const parts = dateFormatter.formatToParts(date);
			const day = parts.find(part => part.type === 'day').value;
			const month = parts.find(part => part.type === 'month').value;
			const year = parts.find(part => part.type === 'year').value;
			return `${day} ${month}, ${year}`;
		} else {
			return "Unsupported language";
		}
	}

	const handleRegistrationOptionButtonClick = (modeOfAttending, data) => {
		toast.dismiss();
		if (!isAuthenticated) {
			toast.warning(t("EVENTS_PAGE.REGISTER_AS_MEMBER_TO_CONTINUE"));
			setTimeout(() => {
				navigate("/register");
			}, 2000);
		} else {
			if (new Date() > new Date(data.registrationStartDate)) {
				setSelectedModeOfAttending(modeOfAttending);
				setSelectedEventDetails({
					id: data._id,
					title: data.title,
					bannerUrl: data.bannerUrl,
					isFoodAvailable: data.isFoodAvailable,
					foodDetails: data.foodDetails ? data.foodDetails : [],
					isTicketed: data.isTicketed,
					requiresRegistration: data.requiresRegistration,
					isVirtualModeEnabled: data.isVirtualModeEnabled
				});
				setShowEventRegistrationModal(true);
			} else {
				toast.info(t("EVENTS_PAGE.REGISTRATION_STARTS_FROM_MESSAGE", {
					registrationStartDate: convertUTCDate(data.registrationStartDate, i18next.resolvedLanguage)
				}));
			}
		}
	}

	useEffect(() => {
		const fetchEventsPageBaseData = async () => {
			try {
				const response = await getAllActiveEvents(axiosPrivate);
				console.log("(NewsAndEvents.jsx) Events Page Base Data: ", response);
				if (response.success) {
					setEventsData(response.data);
				} else {
					toast.dismiss()
					toast.error(response.error);
				}
			} catch (error) {
				console.log("(NewsAndEvents.jsx) Error fetching Events Page Base Data: ", error);
				toast.dismiss()
				toast.error(error.message);
			} finally {
				setLoadingEventsPageBaseData(false);
			}
		}

		fetchEventsPageBaseData();
		// window.scrollTo(0, 0);
	}, []);

	useEffect(() => {
		console.log("Updated Events Data: ", eventsData);
	}, [eventsData]);

	useEffect(() => {
		if (!isAuthenticated) {
			navigate("/login", {
				replace: true,
			});
		}
	}, []);

	if (loadingEventsPageBaseData) {
		return (
			<div className={"w-[100dvw] h-[100dvh] bg-[#F7F7F7] flex items-center justify-center"}>
				<Header/>
				<h1 className={"text-[5vw] font-custom-mono-bold"}>
					Loading...
				</h1>
			</div>
		)
	}

	return (
		<>
			<div className="w-screen bg-[#F7F7F7] flex flex-col items-center justify-center">
				<Header/>

				{/* Background Image */}
				<img
					src="/banners/banner-karyakram-batmya.jpg"
					alt="Event Banner"
					className="w-full object-cover shadow-lg"
				/>

				{/* Events Grid */}
				<div
					className="max-w-6xl flex flex-col items-center justify-center
                        gap-6 portrait:p-[0.75rem] portrait:pb-[4rem]
                        landscape:p-[0.5rem] landscape:pb-[2rem]"
				>
					{eventsData.map((data, index) => (
						// portrait:gap-[0.625rem] portrait:jk:gap-[0.875rem] portrait:lg:gap-[1.125rem]
						// landscape:gap-[0.375rem] landscape:jk:gap-[0.45rem] landscape:lg:gap-[0.575rem]
						<div
							key={index}
							className={`flex flex-col bg-white shadow-lg shadow-black/10 rounded-xl
                                
                                portrait:p-[0.75rem] portrait:jk:p-[1.75rem] portrait:lg:p-[2.25rem]
                                landscape:p-[0.75rem] landscape:jk:p-[0.9rem] landscape:lg:p-[1.15rem]
                                
                                portrait:gap-[0.75rem] portrait:jk:gap-[1.75rem] portrait:lg:gap-[2.25rem]
                                landscape:gap-[0.75rem] landscape:jk:gap-[0.9rem] landscape:lg:gap-[1.15rem]
                            `}
						>
							<img
								src={data.bannerUrl}
								alt={`Event ${index + 1}`}
								className="rounded-xl w-full aspect-auto object-contain"
							/>

							{
								data.isTicketBooked
									? (
										<div className={`flex justify-end items-center w-full`}>
											<button
												className={`landscape:w-fit portrait:w-full justify-center
                                                    flex items-center gap-2 bg-[#D26A53]
                                                    portrait:px-[0.95rem] portrait:py-[0.5rem]
                                                    portrait:md:px-[0.75rem] portrait:md:py-[0.45rem]
                                                    portrait:jk:px-[0.85rem] portrait:jk:py-[0.55rem]
                                                    portrait:lg:px-[1rem] portrait:lg:py-[0.75rem]

                                                    landscape:px-[0.75rem] landscape:py-[0.35rem]
                                                    landscape:jk:px-[0.85rem] landscape:jk:py-[0.4rem]
                                                    landscape:lg:px-[1rem] landscape:lg:py-[0.5rem]

                                                    rounded-lg shadow-lg  shadow-black/5
                                                    hover:ring-4 hover:ring-orange-300 hover:ring-offset-1
                                                    transition duration-300 ease-out`}
												onClick={() => {
													toast.dismiss();
													if (!isAuthenticated) {
														toast.warning(t("EVENTS_PAGE.REGISTER_AS_MEMBER_TO_CONTINUE"));
														setTimeout(() => {
															navigate("/register");
														}, 1000);
													} else {
														if (data._id) {
															setSelectedEventDetails({
																id: data._id,
																title: data.title,
																bannerUrl: data.bannerUrl,
																isFoodAvailable: data.isFoodAvailable,
																foodDetails: data.foodDetails ? data.foodDetails : [],
																isTicketed: data.isTicketed,
																requiresRegistration: data.requiresRegistration
															});
															setSelectedTicketDetails({
																_id: data.ticketDetails._id,
																userId: data.ticketDetails.userId,
																eventId: data.ticketDetails.eventId,
																numberOfSeats: data.ticketDetails.numberOfSeats,
																qrCodeBase64: data.ticketDetails.qrCodeBase64,
																rowNumber: data.ticketDetails.rowNumber,
																modeOfAttending: data.ticketDetails.modeOfAttending
															})
															setShowEventTicketModal(true);
														} else {
															toast.info(t("CONSTANTS.SOMETHING_WENT_WRONG"));
														}
													}
												}}
											>
												<p
													className={`font-custom-medium text-white leading-tight
                                                        line-clamp-1 overflow-x-scroll no-scrollbar
                                                        portrait:text-[1rem] portrait:md:text-[1.25rem] 
                                                        portrait:jk:text-[1.15rem] landscape:text-[0.8rem]
                                                        landscape:md:text-[0.85rem] landscape:jk:text-[1rem]`}
												>
													{t("EVENTS_PAGE.VIEW_TICKET")}
												</p>

												<div
													className="flex items-center justify-center aspect-square
                                                    portrait:h-[1.25rem] portrait:md:h-[0.95rem] portrait:jk:h-[0.9rem]
                                                    landscape:h-[0.65rem] landscape:md:h-[0.75rem] landscape:jk:h-[1rem]"
												>
													<img
														src={"/assets/seats-icon.svg"}
														className={"h-full aspect-square"}
														alt={"Zoom"}
													/>
												</div>
											</button>
										</div>
									) : (
										<div
											className={`flex portrait:flex-col items-center 
                                                ${data.isVirtualModeEnabled ? 'justify-between' : 'justify-end'}
                                                portrait:gap-y-[0.75rem] portrait:jk:gap-y-[1.75rem] portrait:lg:gap-y-[2.25rem]
                                                landscape:gap-y-[0.75rem] landscape:jk:gap-y-[0.9rem] landscape:lg:gap-y-[1.15rem]`}
										>
											{/* Attend Virtually on Zoom */}
											{
												data.isVirtualModeEnabled && (
													<button
														className="portrait:w-full portrait:justify-center
                                                            flex items-center gap-2 h-[5vh] w-fit
                                                            bg-white p-[1vh] pl-[1.75vh]
                                                            rounded-lg shadow-lg  shadow-black/5
                                                            border-2 border-[#EAEAEA]
                                                            hover:ring-4 hover:ring-[#2196F3]
                                                            hover:ring-offset-2
                                                            transition duration-300 ease-out"
														onClick={() => handleRegistrationOptionButtonClick("VIRTUAL", data)}
													>
														<p
															className={`font-custom-medium text-gray-900 leading-tight
                                                                line-clamp-1 overflow-x-scroll no-scrollbar
                                                                portrait:text-[1rem] portrait:md:text-[1.25rem] 
                                                                portrait:jk:text-[1.15rem] landscape:text-[0.8rem]
                                                                landscape:md:text-[0.85rem] landscape:jk:text-[1rem]`}
														>
															{t("EVENTS_PAGE.REGISTRATION_OPTIONS.VIRTUAL")}
														</p>

														<div
															className="flex items-center justify-center aspect-square
                                                                portrait:h-[1.4rem] portrait:md:h-[0.95rem] portrait:jk:h-[0.9rem]
                                                                landscape:h-[0.65rem] landscape:md:h-[0.75rem] landscape:jk:h-[1.5rem]"
														>
															<img
																src={"/assets/zoom-company-icon.svg"}
																className={"h-full aspect-square"}
																alt={"Zoom"}
															/>
														</div>
													</button>
												)
											}

											{/* Attend Physically at Venue */}
											<button
												className="portrait:w-full portrait:justify-center
                                                    flex items-center gap-2 h-[5vh] w-fit
                                                    bg-white p-[1vh] pl-[1.75vh]
                                                    rounded-lg shadow-lg  shadow-black/5
                                                    border-2 border-[#EAEAEA]
                                                    hover:ring-4 hover:ring-[#A20000]
                                                    hover:ring-offset-2
                                                    transition duration-300 ease-out"
												onClick={() => handleRegistrationOptionButtonClick("PHYSICAL", data)}
											>
												<p
													className={`font-custom-medium text-gray-900 leading-tight
                                                        line-clamp-1 overflow-x-scroll no-scrollbar
                                                        portrait:text-[1rem] portrait:md:text-[1.25rem] 
                                                        portrait:jk:text-[1.15rem] landscape:text-[0.8rem]
                                                        landscape:md:text-[0.85rem] landscape:jk:text-[1rem]`}
												>
													{t("EVENTS_PAGE.REGISTRATION_OPTIONS.PHYSICAL")}
												</p>

												<div
													className="flex items-center justify-center aspect-square
                                                        portrait:h-[1.4rem] portrait:md:h-[0.95rem] portrait:jk:h-[0.9rem]
                                                        landscape:h-[0.65rem] landscape:md:h-[0.75rem] landscape:jk:h-[1.5rem]"
												>
													<img
														src={"/assets/venue-icon.svg"}
														className={"h-full aspect-square"}
														alt={"Venue"}
													/>
												</div>
											</button>
										</div>
									)
							}
						</div>
					))}
				</div>
			</div>

			{
				isAuthenticated && (
					<>
						<EventRegistrationForm
							setEventsData={setEventsData}
							showEventRegistrationModal={showEventRegistrationModal}
							setShowEventRegistrationModal={setShowEventRegistrationModal}
							selectedModeOfAttending={selectedModeOfAttending}
							setSelectedModeOfAttending={setSelectedModeOfAttending}
							selectedEventDetails={selectedEventDetails}
							setSelectedEventDetails={setSelectedEventDetails}
							showEventTicketModal={showEventTicketModal}
							setShowEventTicketModal={setShowEventTicketModal}
							setSelectedTicketDetails={setSelectedTicketDetails}
						/>

						<EventTicketModal
							selectedEventDetails={selectedEventDetails}
							ticketDetails={selectedTicketDetails}
							setTicketDetails={setSelectedTicketDetails}
							showEventTicketModal={showEventTicketModal}
							setShowEventTicketModal={setShowEventTicketModal}
						/>
					</>
				)
			}
		</>
	);
};
